<div [formGroup]="parentForm">
  <p-select
    [id]="id"
    [name]="name"
    [options]="options"
    [formControlName]="control"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    optionDisabled="inactive"
    [placeholder]="placeholder"
    [style]="style"
    [panelStyleClass]="panelStyleClass"
    [showClear]="showClear"
    [styleClass]="class"
    [filter]="filter"
    [disabled]="disabled"
    [virtualScroll]="virtualScroll"
    [virtualScrollItemSize]="itemSize"
    (onChange)="dropdownChange($event)"
    (onBlur)="dropdownBlur($event)"
    (onClear)="dropdownClear($event)"
  >
  </p-select>
</div>

